import { BookingType, ParkingType } from './utilTypes';

export type BookingWithGateDescription = BookingType & {
  gateDescription: string;
};

export const getAllUpcomingBookings = (
  parking?: ParkingType
): BookingWithGateDescription[] => {
  if (!parking) return [];

  // Get bookings from current parking
  const currentBookings: BookingWithGateDescription[] =
    parking.devices?.flatMap((device) =>
      device.gates.flatMap((gate) => {
        return (
          gate.bookings
            // .filter((booking) => {
            //   const startDate = new Date(booking.startsAt);
            //   return startDate > new Date();
            // })
            .map((booking) => ({
              ...booking,
              gateDescription: gate.description || '',
            }))
        );
      })
    ) || [];

  // Get bookings from referenced parkings recursively
  const referencedBookings: BookingWithGateDescription[] =
    parking.referencedBy?.flatMap((referencedParking) =>
      getAllUpcomingBookings(referencedParking)
    ) || [];

  return [...currentBookings, ...referencedBookings];
};

export const flattenBookings = (session: any) => {
  if (!session?.parking) return [];

  const bookings = [
    ...(session.parking.referenceParking?.bookings ?? []).map(
      (booking: any) => ({
        ...booking,
        parkingId: session.parking.referenceParking.id,
      })
    ),
    ...(session.parking.bookings ?? []).map((booking: any) => ({
      ...booking,
      parkingId: session.parking.id,
    })),
  ];

  return bookings;
};
